import React from 'react'

export const marylandSetupVars = {
  siteId: 'maryland',
  pathPrefix: '/md',
  menuHeader: "Discover Maryland's Solution for:",
  appUrl: 'https://md.headed2.com',
  logoImg: '/images/assets/maryland/horizontal/dark.svg',
  headerTitle: `The Maryland CareerExplorer is a system designed for Maryland`
}
